<script setup lang="ts">
import { Library, Tags } from '@lucide/vue'
import TankoMark from './tanko-mark.vue'
import { Sidebar, SidebarBody, SidebarFooter, SidebarHeader, SidebarItem, SidebarLabel, SidebarSection } from 'catalyst-vue'
import { useRoute, useRouter } from 'vue-router'

/**
 * 側邊欄只負責導覽。分類篩選在書庫頁的工具列，分類管理在 /categories。
 */
const route = useRoute()
const router = useRouter()
</script>

<template>
  <Sidebar class="bookshop-sidebar">
    <SidebarHeader><div class="shop-brand"><TankoMark :size="22" /><span>Tanko</span></div></SidebarHeader>
    <SidebarBody>
      <SidebarSection>
        <SidebarItem :current="route.path === '/library'" @click="router.push('/library')">
          <Library data-slot="icon" :size="18" aria-hidden="true" /><SidebarLabel>書庫</SidebarLabel>
        </SidebarItem>
        <SidebarItem :current="route.path === '/categories'" @click="router.push('/categories')">
          <Tags data-slot="icon" :size="18" aria-hidden="true" /><SidebarLabel>分類管理</SidebarLabel>
        </SidebarItem>
      </SidebarSection>
    </SidebarBody>
    <!-- 只有一份書庫，頁尾不再標示範圍——沒有第二個範圍可以區分。 -->
    <SidebarFooter class="bookshop-sidebar-footer"><p class="sidebar-note"><Library :size="14" aria-hidden="true" />Tanko 書庫</p></SidebarFooter>
  </Sidebar>
</template>
